import { IVideoTime } from '~/types/sanity-objects';

export function convertVideoTimeToSecs(videoTime: IVideoTime) {
  return (
    (videoTime?.hours ?? 0) * 3600 +
    (videoTime?.minutes ?? 0) * 60 +
    (videoTime?.seconds ?? 0)
  );
}
